const InventoryQueryView = require('./views/InventoryQuery.html')
export default {
    base: {
        state: 'outputManage.stock.InventoryQuery',
        config: {
            url: '/InventoryQuery',
            abstract: true,
            template: '<div ui-view></div>',
            // controller: 'declareInventoryQueryCtrl',
        },
    },
    list: {
        state: 'outputManage.stock.InventoryQuery.list',
        config: {
            url: '/list',
            template: InventoryQueryView,
            controller: 'InventoryQueryCtrl',
            title: '库存查询',
        },
    },
}



// WEBPACK FOOTER //
// ./src/app/outputManage/stock/InventoryQuery/routers.js